import { useEffect, useState } from "react";
import api from "../api";
import toast from "../utils/toast";
import "./UserManager.css";

export default function UserManager() {
  const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);
  const [nuevo, setNuevo] = useState({
    nombre: "",
    password: "",
    rol: "vendedor",
  });
  const [err, setErr] = useState("");

  const cargar = async () => {
    try {
      setErr("");
      const { data } = await api.get("/api/usuarios");
      setUsuarios(data?.rows || data || []);
    } catch (e) {
      setErr(e?.response?.data?.error || e.message);
    }
  };

  const cargarRoles = async () => {
    try {
      const { data } = await api.get("/api/roles");
      const list = Array.isArray(data) ? data : [];
      setRoles(list);
      if (list.length && !list.some((r) => r.codigo === nuevo.rol)) {
        setNuevo((n) => ({ ...n, rol: list[0].codigo }));
      }
    } catch (_) {
      setRoles([]);
    }
  };

  useEffect(() => {
    cargar();
    cargarRoles();
  }, []);

  const agregar = async () => {
    if (!nuevo.nombre.trim() || !nuevo.password.trim()) {
      return toast("Completa usuario y contraseña");
    }
    if (nuevo.password.trim().length < 6) {
      return toast("La contraseña debe tener al menos 6 caracteres");
    }
    try {
      await api.post("/api/usuarios/crear", nuevo);
      setNuevo((n) => ({ nombre: "", password: "", rol: roles[0]?.codigo || n.rol }));
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "Error al agregar usuario");
    }
  };

  const toggleActivo = async (u) => {
    try {
      await api.put(`/api/usuarios/${u.id}`, {
        ...u,
        activo: !u.activo,
      });
      cargar();
    } catch (e) {
      toast("No se pudo actualizar");
    }
  };

  const eliminar = async (u) => {
    if (!window.confirm(`Eliminar "${u.nombre}"?`)) return;
    try {
      const { data } = await api.delete(`/api/usuarios/${u.id}`);
      toast(data?.message || "Usuario eliminado", "exito");
      cargar();
    } catch (e) {
      toast(e?.response?.data?.error || "No se pudo eliminar");
    }
  };

  return (
    <div className="um-wrapper">
      <div className="um-card">
        <div className="um-header">
          <div>
            <h2>Mantenedor de Usuarios</h2>
            <p className="um-subtitle">
              Administra los usuarios que pueden usar Caja POS.
            </p>
          </div>
          <span className="um-badge">
            {usuarios.length} usuario{usuarios.length === 1 ? "" : "s"}
          </span>
        </div>

        {/* Formulario alta usuario */}
        <div className="um-form">
          <div className="um-field">
            <label>Usuario</label>
            <input
              placeholder="Ej: Vendedor1"
              value={nuevo.nombre}
              onChange={(e) =>
                setNuevo({ ...nuevo, nombre: e.target.value })
              }
            />
          </div>

          <div className="um-field">
            <label>Contraseña</label>
            <input
              placeholder="Mín. 6 caracteres"
              type="password"
              value={nuevo.password}
              onChange={(e) =>
                setNuevo({ ...nuevo, password: e.target.value })
              }
            />
            {nuevo.password.length > 0 && nuevo.password.length < 6 && (
              <span style={{ color: "#e53e3e", fontSize: 12, marginTop: 4, display: "block" }}>
                Mínimo 6 caracteres ({nuevo.password.length}/6)
              </span>
            )}
          </div>

          <div className="um-field">
            <label>Rol</label>
            <select
              value={nuevo.rol}
              onChange={(e) =>
                setNuevo({ ...nuevo, rol: e.target.value })
              }
            >
              {roles.map((r) => (
                <option key={r.id} value={r.codigo}>
                  {r.nombre}
                </option>
              ))}
              {roles.length === 0 && (
                <>
                  <option value="vendedor">Vendedor</option>
                  <option value="superadmin">Superadmin</option>
                </>
              )}
            </select>
          </div>

          <div className="um-actions">
            <button className="um-btn um-btn-primary" onClick={agregar}>
              Agregar
            </button>
          </div>
        </div>

        {err && <div className="um-error">Error: {err}</div>}

        {/* Tabla usuarios */}
        <div className="um-table-wrap">
          <table className="um-table">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Rol</th>
                <th>Estado</th>
                <th className="um-col-actions">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map((u) => (
                <tr key={u.id}>
                  <td>{u.nombre}</td>
                  <td>
                    <span className="um-tag">
                      {roles.find((r) => r.codigo === u.rol)?.nombre || u.rol}
                    </span>
                  </td>
                  <td>
                    <span
                      className={
                        u.activo ? "um-pill um-pill-ok" : "um-pill um-pill-off"
                      }
                    >
                      {u.activo ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td className="um-col-actions">
                    <button
                      className="um-btn um-btn-ghost"
                      onClick={() => toggleActivo(u)}
                    >
                      {u.activo ? "Desactivar" : "Activar"}
                    </button>
                    <button
                      className="um-btn um-btn-danger"
                      onClick={() => eliminar(u)}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}

              {usuarios.length === 0 && (
                <tr>
                  <td colSpan={4} className="um-empty">
                    No hay usuarios registrados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
